import { FC, memo } from "react";
import styles from "./product-card-1.module.css";
import HighlightStarBox from "../../components/highlight-star-box";
import DiscountBadge from "../../components/discount-badge";
import WholesaleBox from "../../components/wholesale-box";
import {
  AppLink,
  useProductCardLogic } from
"@commons-monorepo/index";
import { ProductCardProps } from "../../product-card.types";
import KitTag from "../../components/kit-tag";

const ProductCard1: FC<Omit<ProductCardProps, "theme">> = ({
  product,
  withTags,
  currency,
  locale
}) => {
  const {
    hasDiscount,
    images,
    percentageDiscount,
    isWholesale,
    isHighlight,
    isKit,
    finalPrice,
    formattedFinalPrice,
    formattedWithoutDiscountPrice,
    urlProduct
  } = useProductCardLogic({ product, currency, locale });

  return (
    <div className={styles.productCard1Wrapper}>
      <img
        loading='lazy'
        alt={product?.name}
        className={styles.productImage}
        src={images[0].url} />

      <div className={styles.overlay} />
      <AppLink to={urlProduct} className={styles.content}>
        <div className={styles.topIndicators}>
          {isKit && withTags && <KitTag />}
          {isHighlight && withTags &&
          <HighlightStarBox className={styles.highlightStarBox} />}

          {isWholesale && withTags &&
          <WholesaleBox className={styles.wholesaleBox} />}

          {!!percentageDiscount &&
          <DiscountBadge
            className={styles.discountBadge}
            percentageDiscount={percentageDiscount} />}


        </div>
        <div className={styles.bottomInfo}>
          <div className={styles.name}>{product.name}</div>
          {finalPrice > 0 &&
          <>
              {hasDiscount && !isKit &&
            <div className={styles.withoutDiscountPrice}>
                  {formattedWithoutDiscountPrice}
                </div>}

              <div className={styles.price}>{formattedFinalPrice}</div>
            </>}

          {isKit &&
          <div className={styles.totalUnitsKit}>
              {product.totalUnits || 0} unidades
            </div>}

        </div>
      </AppLink>
    </div>);

};

export default memo(ProductCard1);